<h1>My Account</h1>
<ul class="menu rav-tabs align-center" data-cy="account-menu">
  <li><a routerLink="/account" routerLinkActive="is-active" [routerLinkActiveOptions]="{ exact: true }">Account</a></li>
  <li>
    <a routerLink="/account/profile" routerLinkActive="is-active" [routerLinkActiveOptions]="{ exact: true }">
      Profile
    </a>
  </li>
  <li *ngIf="scope.hasAccess(scope.scope.UserRead)">
    <a routerLink="/account/users" routerLinkActive="is-active" [routerLinkActiveOptions]="{ exact: true }">Users</a>
  </li>
  <li *ngIf="scope.hasAccess(scope.scope.AccountRead)">
    <a routerLink="/account/connections" routerLinkActive="is-active" [routerLinkActiveOptions]="{ exact: true }">
      Connections
    </a>
  </li>
  <li *ngIf="scope.hasAccess(scope.scope.UserWrite)">
    <a routerLink="/account/preferences" routerLinkActive="is-active" [routerLinkActiveOptions]="{ exact: true }">
      Preferences
    </a>
  </li>
</ul>
<div class="rav-page">
  <router-outlet></router-outlet>
</div>
